import { Grid, Stack, Typography } from '@mui/material';

export const IntakeColumn = ({ title, children }: { title: string; children: React.ReactNode }) => {
  return (
    <Grid size={{ xs: 12, md: 4 }}>
      <Stack
        spacing={4}
        sx={{
          alignItems: { md: 'center', xs: 'stretch' },
          maxWidth: { xs: '600px', md: 'none' },
          margin: { xs: 'auto', md: 'unset' },
          padding: { xs: 3, md: 'unset' },
        }}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: 'center',
          }}
        >
          <Typography align="center" variant="h6">
            {title}
          </Typography>
        </Stack>

        {children}
      </Stack>
    </Grid>
  );
};
